@if (settings()) {
  <div class="list-toolbar-container">
    @if (!disabled() && settings().isGlobalSearchEnabled) {
      <mat-form-field class="list-toolbar-search">
        <input
          matInput
          placeholder="{{ 'Search' | translate }}"
          [formControl]="globalSearchControl"
          #globalSearch
          (mousedown)="stopInputPropagation($event)"
          (click)="stopInputPropagation($event)"
          (keydown)="stopInputPropagation($event)" />
        </mat-form-field>
      }
      <ng-container *ngTemplateOutlet="isCollapsed() ? smallToolbar : largeToolbar" />
      <ng-template #smallToolbar>
        <span class="hamburger-section-menu list-buttons-container">
          <button type="button" mat-button [matMenuTriggerFor]="menu" [disabled]="disabled()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <ng-container [ngTemplateOutlet]="buttons" />
          </mat-menu>
        </span>
      </ng-template>
      <ng-template #largeToolbar>
        <span class="list-buttons-container">
          <ng-container [ngTemplateOutlet]="buttons" />
        </span>
      </ng-template>
    </div>
  }

  <ng-template #buttons>
    <div class="list-toolbar-buttons-container" (click)="$event.stopPropagation()">
      <button
        type="button"
        mat-button
        (click)="changeGlobalSearchVisibility(!settings().isGlobalSearchEnabled)"
      [class]="{
        'list-toolbar-element-unchecked': !settings().isGlobalSearchEnabled,
        'list-toolbar-element-checked': settings().isGlobalSearchEnabled
      }"
        [disabled]="disabled()"
        [matTooltip]="'View.ActivateSearch' | translate"
        matTooltipPosition="below">
        @if (!settings().isGlobalSearchEnabled) {
          <mat-icon>search</mat-icon>
        }
        @if (settings().isGlobalSearchEnabled) {
          <mat-icon>search_off</mat-icon>
        }
      </button>

      <button
        type="button"
        mat-button
        (click)="changeFiltersVisibility(!settings().areFiltersEnabled)"
      [class]="{
        'list-toolbar-element-checked': settings().areFiltersEnabled,
        'list-toolbar-element-unchecked': !settings().areFiltersEnabled
      }"
        [disabled]="disabled()"
        [matTooltip]="'View.ActivateFilters' | translate"
        matTooltipPosition="below">
        <mat-icon>filter_alt</mat-icon>
      </button>

      <app-view-selector (viewTabsVisibilityChange)="viewTabsVisibilityChange.emit($event)"
        [disabled]="disabled()"
        [viewTabs]="viewTabs()"
        [selectionMode]="viewTabsSelectionMode()"
        [matTooltip]="(viewTabsSelectionMode() === 'multi' ? 'View.SelectViews' : 'View.SelectView') | translate"
        matTooltipPosition="below" />

      @if (canBulkUpdate()) {
        <button
          type="button"
          mat-button
          (click)="bulkUpdate.emit()"
          [disabled]="disabled()"
          [matTooltip]="'View.BulkUpdate' | translate"
          matTooltipPosition="below">
          <mat-icon>edit_note</mat-icon>
        </button>
      }

      <button
        type="button"
        mat-button
        (click)="refreshData.emit(undefined)"
        [disabled]="disabled()"
        [matTooltip]="'View.RefreshData' | translate"
        matTooltipPosition="below">
        <mat-icon>autorenew</mat-icon>
      </button>

      <button
        type="button"
        mat-button
        (click)="onRestoreSettingsClick()"
        [disabled]="disabled()"
        [matTooltip]="'View.RestoreSettings' | translate"
        matTooltipPosition="before">
        <mat-icon>settings_backup_restore</mat-icon>
      </button>

      <button
        type="button"
        mat-button
        (click)="navigateToSettings.emit(undefined)"
        [disabled]="disabled()"
        [matTooltip]="'View.ViewSettings' | translate"
        matTooltipPosition="before">
        <mat-icon>settings</mat-icon>
      </button>
    </div>
  </ng-template>
